import {observable, computed, autorun, map} from 'mobx';

let dbFields = [ 'id','created_at','type','id_customer','id_machine','delivery',
 'end_of_contract','support_paid_till'];
 let dateFields = [ 'created_at','end_of_contract','support_paid_till','delivery'];

// For now this is just a blind copy of the rows from the database.
function createContractFromDBRow(row) {
  //console.log(JSON.stringify(row));
  var c = new Contract();
  dbFields.forEach( f => {
    c[f]=row['contract_'+f] || row[f];
    //console.log(f, c[f]);
  })
  dateFields.forEach( f => {
    if(c[f]) c[f]=new Date(c[f]);
  })
  return c;
}

// One contract represents an agreement by a customer to buy or rent a
// machine.
export default class Contract {
  @observable id = null;
  @observable created_at = null;
  // Buy vs Hire
  @observable type = null;
  @observable id_customer = null;
  @observable id_machine = null;
  @observable delivery = null;
  // For "Hire" contacts :
  @observable end_of_contract = null;
  // For "Buy" contracts :
  @observable support_paid_till = null;

  @computed get validInsert() {
    if(!this.delivery) return false;
    if(this.type=='Hire' || this.type=='Pilot') return this.end_of_contract != null;
    if(this.type=='Support') return this.support_paid_till != null;
    return true;
  }

}



// Make utility method available from Class (function)
Contract.createFromDBRow=createContractFromDBRow;



/** WEBPACK FOOTER **
 ** ./src/DataModel/Contract.js
 **/